import {Component, h, Fragment} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {Link, Redirect} from "react-router-dom";
import {
    fetchAcademicPrograms,
    fetchOffer,
    fetchStates,
    updateOfferStatus,
    clearOffer,
    clearApplications,
    fetchOffers, fetchCandidatesCount
} from "../_rx/jobs/actions";
import {C, E, FR} from "../_common/layout";
import {formatDDMMYYYY, isMobileAgent} from "../_common/common";
import Applications from './components/applications'
import {AcademicProgram, State} from "../_api";
import Dropdown from "../_common/components/dropdown";
import {t} from "../_i18n";
import OfferBadgesContainer from "../_common/components/offerBadgesContainer/OfferBadgesContainer";
import {Helmet} from "react-helmet";
import {OFFERS_LIST_TITLE_PAGE} from "../constants";
import Badge from "../_common/components/Badge";

const modalityFix: any = {
    modality_normal: 'Oferta de trabajo',
    modality_fct: 'Formación en centro de trabajo (FCT)',
    modality_dual: 'Dual'
}

const UNPUBLISHED: string = 'unpublished';
const PUBLISHED: string = 'published';


const mapStateBadges : {[key:string]: string} = {
    'applied': 'dark-gray',
    'accepted': 'dark-gray',
    'selected': 'dark-green',
    'discarded': 'dark-red'

}

const statuses : {[key:string]: string} = {
    "applied": t("Por leer"),
    "accepted": t("En proceso"),
    "selected": t("Finalistas"),
    "discarded": t("Descartados")
}


type Props = {
    offerReducer:any,
    fetchOffer: typeof fetchOffer,
    fetchOffers: typeof fetchOffers,
    match: any,
    status: string,
    fixtures: {academic_programs: AcademicProgram[], states: State[]},
    fetchAcademicPrograms: typeof fetchAcademicPrograms,
    fetchStates: typeof fetchStates,
    updateOfferStatus: typeof updateOfferStatus,
    clearOffer: typeof clearOffer,
    clearApplications: typeof clearApplications,
    history: any
}

class View extends Component<Props, {}> {

    state = {
        isMobile: isMobileAgent(),
        academicProgramsOffer: [],
        academicProgramSaved: false
    }

    async componentDidMount() {
        await this.props.fetchOffer({id: this.props.match.params.id});

        if (this.props.fixtures.academic_programs && this.props.offerReducer.offerSelected.academicPrograms)
            this.setState({ academicProgramsOffer: this.props.offerReducer.offerSelected.academicPrograms.map((id:any) => this.props.fixtures.academic_programs[id])})

        if(!this.props.fixtures.academic_programs) // lazy
            await this.props.fetchAcademicPrograms();

        if(!this.props.fixtures.states) // lazy
            await this.props.fetchStates();
    }

    componentDidUpdate(previousProps: Readonly<Props>) {
        const offerSelected = this.props.offerReducer?.offerSelected;
        if (previousProps.offerReducer.offerSelected !== offerSelected){
            if(this.props.fixtures.academic_programs && !this.state.academicProgramSaved) {
                this.props.offerReducer.offerSelected.academicPrograms
                this.setState({
                    academicProgramsOffer: this.props.offerReducer.offerSelected.academicPrograms.map((id: any) => this.props.fixtures.academic_programs[id]),
                    academicProgramSaved: true
                })
            }
        }

    }

    async updateOffer(status: string) {
        await this.props.updateOfferStatus({id:  this.props.match.params.id, status: {status: status}})
        this.props.history.push('/offers')
    }

    componentWillUnmount() {
        this.props.clearOffer()
        this.props.clearApplications();
    }


    render({ offerReducer, fixtures}:Props) {
        const offerSelected = offerReducer.offerSelected;

        if(!fixtures.academic_programs) return null;
        if(!fixtures.states) return null;

        const tab = this.props.match.params.status || 'applied';

        return <div className='container-fluid max-width-980'>
            {(offerSelected) && <Fragment>
                <Helmet>
                    <title>{offerSelected.title} | ILERNA</title>
                </Helmet>
                <C>
                    <Link to='/offers'><span>Inicio</span></Link>
                    <span className='p-left p-right'>/</span>
                    <span>Oferta</span>
                </C>
                <C>
                    <FR className='flex-center-y'>
                        <E className='col-90'><h1 className='no-margin-bottom'>{offerSelected.title}</h1></E>
                        <E className='col-10 flex-right d-flex'>
                            <Dropdown icon='fas fa-ellipsis-v' position='left' justIcon isGrey>
                                <div className='dropdown-item'><Link to={'/offers/'+offerSelected.id+'/edit'}>{t('Editar oferta')}</Link></div>
                                <div className='dropdown-item'><Link to={{pathname: `/offers/${offerSelected.id}/preview`, state: { prevPath: location.pathname }}}>{t('Previsualizar oferta')}</Link></div>
                                    {(offerSelected.status === UNPUBLISHED) &&
                                        <Fragment>
                                            <div className='dropdown-item' onClick={() => this.updateOffer('delete')}><Link to={'/drafts'}>{t('Eliminar borrador')}</Link></div>
                                            <div className='dropdown-item__btn p-left p-right'>
                                              <div className="btn btn-ghost info  m-top" onClick={() => this.updateOffer(PUBLISHED)}><span className={'text-info text-normal'}>{t('Publicar')}</span></div>
                                            </div>
                                        </Fragment>
                                    }
                                    {
                                        (offerSelected.status === PUBLISHED) &&
                                        <div className='dropdown-item__btn p-left p-right'>
                                            <div className="btn btn-ghost danger  m-top" onClick={() => this.updateOffer('closed')}><span className={'text-danger text-normal'}>{t('Cerrar Proceso')}</span></div>
                                        </div>
                                    }
                            </Dropdown>
                        </E>

                    </FR>
                </C>
                <C>
                    <FR >
                        <E className='font-14'>
                            <span className='medium-weight sm-d-line d-block p-bottom sm-no-p-bottom'>{modalityFix[`modality_${offerSelected.modality}`]}</span>
                            <span className='p-left p-right translucent d-none sm-d-line'>|</span>
                            {(offerSelected.presence === 'remote')
                                ?<span className='translucent m-top'>{t('Teletrabajo')}</span>
                                :<span className='translucent m-top'>{offerSelected.city}{` (${fixtures.states[offerSelected.state]})`}</span>}
                            {(offerSelected.status !== UNPUBLISHED) && offerSelected.date  && <Fragment>
                                <span className='p-left p-right translucent d-none sm-d-line'>|</span>
                                {<span className='translucent sm-d-line d-block'>Publicada: {formatDDMMYYYY(offerSelected.date)}</span>}
                            </Fragment>
                            }
                        </E>
                    </FR>
                </C>
                <C>
                    <FR className='p-top'>
                        <OfferBadgesContainer academicProgramList={this.state.academicProgramsOffer} isMobile={this.state.isMobile} numberMax={60}/>
                    </FR>
                </C>
                <C className='p-top'>
                    <FR className="tabs-container sm-p-left">
                        {offerSelected.counts.map((label: any, index: number) =>
                            <div className="inline p-bottom sm-no-p-bottom no-padding-right sm-m-right" key={index}>
                                <Link to={`/offers/${offerSelected.id}/${label.state}`} className={tab === label.state ? 'selected' : ''}>
                                    <span className='p-right cursor-pointer'>{statuses[label.state]}</span>
                                    <Badge type={mapStateBadges[label.state]} className='light'><span>{label.count}</span></Badge>
                                </Link>
                            </div>
                        )}
                    </FR>
                </C>
                <C>
                    {<Applications tab={tab} id={this.props.match.params.id} />}
                </C>
            </Fragment>}
        </div>
    }
}


const ConnectedView: any = connect(
    ({offerReducer, fixtures, ...props}:any)=>({offerReducer, fixtures, props}), {fetchOffer, fetchAcademicPrograms, fetchStates, updateOfferStatus, clearOffer, clearApplications, fetchOffers})(View as any);

export default ({archived=false, ...rest}) =>
    <AppPage
        name="offer"
        subtitle=""
        className="max-width-980">
        <ConnectedView {...rest} />

    </AppPage>
;
